var DEFAULT_PICKUP_POINT_PARAM_NAME = 'pickup_dispenser';
var DEFAULT_DROPOFF_POINT_PARAM_NAME = 'dropoff_ingestor';
var DEFAULT_CLEANING_ZONE_PARAM_NAME = 'is_cleaning_zone';
export function getPlaces(buildingMap) {
    var places = new Map();
    for (var _i = 0, _a = buildingMap.levels; _i < _a.length; _i++) {
        var level = _a[_i];
        for (var _b = 0, _c = level.nav_graphs; _b < _c.length; _b++) {
            var graphs = _c[_b];
            for (var _d = 0, _e = graphs.vertices; _d < _e.length; _d++) {
                var vertex = _e[_d];
                if (!vertex.name) {
                    continue;
                }
                var place = { level: level.name, vertex: vertex };
                for (var _f = 0, _g = vertex.params; _f < _g.length; _f++) {
                    var p = _g[_f];
                    if (p.name === DEFAULT_PICKUP_POINT_PARAM_NAME) {
                        place.pickupHandler = p.value_string;
                    }
                    if (p.name === DEFAULT_DROPOFF_POINT_PARAM_NAME) {
                        place.dropoffHandler = p.value_string;
                    }
                    if (p.name === DEFAULT_CLEANING_ZONE_PARAM_NAME) {
                        place.cleaningZone = true;
                    }
                }
                places.set(vertex.name, place);
            }
        }
    }
    return Array.from(places.values());
}
